import React from 'react'
import { connect } from 'react-redux'
import { Link } from "react-router"
import Ajax from 'superagent'
import { sortBy } from "lodash"
import { Modal, Glyphicon, Tabs, Tab } from 'react-bootstrap'
import moment from "moment"
import { DateTimePicker } from 'react-widgets'
import DocumentTitle from "react-document-title"
// import Json from "react-json-view"

import { updateTrip } from '../ducks/trips'
import Button from '../components/Button'
import { getAllActivities, getAllTrips, getNoPubliTagId } from '../selectors'
import { date2str } from '../../lib/Tools'
import HoverTip from '../components/HoverTip'
import { tripHasPartnerAdvertising } from  '../../lib/advertisingTools'

import "./DocumentsReport.less"
import PartnerPayments from './PartnerPayments'
import DocumentedTrips from './DocumentedTrips';

/**
 * NOTE: dates in this page use YYYY-MM-DD instead of
 * our usual YYYY-MM-DD.
 */

const pagesExplanation = (
  "Algunas páginas del documento se pueden desactivar a voluntad. "
  + "En general se trata de actividades, pero también las descripciones "
  + "de las ciudades, el tícket, y la página del último día."
)

const Timestamp = ({ ts }) => (
  <HoverTip text={ts}><span><Glyphicon glyph="time" /> {moment(ts).format("LL")}</span></HoverTip>
)

class AdvertisingPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      documentedTrips: null,
      partners: null,
      partner:null,
      
      prueba: null, 
      modalDoc: null, 
      tripModalId: null,
      docModalIdx: null,
      from: moment().startOf("month").format("YYYY-MM-DD"),
      to: moment().endOf("month").format("YYYY-MM-DD"),
      partnerKey: null
    }
  }
  
  updateDocs() {
    Ajax.get(`/getDocumentsReport/${this.state.from}/${this.state.to}`)
      .then(res => {
        this.setState({ documentedTrips: res.body.trips })
      })
      .catch(err => console.log(err))
  }
  
  updatePartners() {
    Ajax.get(`/partners`)
      .then(res => {
        this.setState({ partners: res.body })
      })
      .catch(err => console.log(err))
  }
  
  refresh() {
    this.updateDocs()
    this.updatePartners()
  }

  componentDidMount() {
    this.updateDocs()
    this.updatePartners()
  }
  
  componentDidUpdate(_prevProps, prevState) {
    if (prevState.from != this.state.from || prevState.to != this.state.to) {
      this.updateDocs()
    }
  }
  
  showModal(tripModalId, docModalIdx) {
    this.setState({ showDocModal: true, tripModalId, docModalIdx })
  }
  
  hideModal() {
    this.setState({ showDocModal: false })
  }
  
  renderActivityMaybe(aid) {
    const a = this.props.Activities[aid]
    return a ? (                   
      <span>{a.name} <Link to={`/private/activity/${encodeURIComponent(aid)}`}>🔗</Link></span>
    ) : (
      <i>{aid}</i>
    )
  }

  addNoPubliTag(tripId) {
    if (confirm("¿Estás seguro? (Puedes deshacer esto quitando la etiquieta al cliente)")) {
      const trip = this.props.Trips[tripId]
      const tag = this.props.noPubliTagId
      this.props.updateTags(tripId, { ...trip.tags, [tag]: true })
    }
  }

  render() {
    if (!this.state.documentedTrips || !this.state.partners) {
      return <h1>Loading</h1>
    }
    
    const { tripModalId, docModalIdx, showDocModal, documentedTrips } = this.state
  
    const documentedTripsList = sortBy(
      Object.values(this.state.documentedTrips), 
      doc => doc.name || doc.realName || doc.officialName
    )
      .filter(t => !this.state.partnerKey || !this.state.partner || tripHasPartnerAdvertising(t, this.state.partner))
    
    const modalDoc = showDocModal && documentedTrips[tripModalId].documents[docModalIdx]

    const publiActivitiesSet = new Set(this.state.partners.map(p => p.publiActivity))

    return (
      <div className="DocumentsReport">
        <DocumentTitle title= {`Documentos`} />
        
        <Tabs 
          activeKey={this.state.partnerKey || "ALL"}
          onSelect={key => this.setState({ partnerKey: (key == "ALL" ? null : key) })}
        >
          <Tab eventKey="ALL" title="Todos los documentos"></Tab>
          {/* #TODO don't hardcode partners (map sobre state.partners) */}
          {
            this.state.partners.map(partner => (
              <Tab eventKey={partner._id} key={partner._id} title={partner.name} />
            ))
          }
        </Tabs>
        
        {
          this.state.partnerKey && (
            <React.Fragment>
              <PartnerPayments partnerId={this.state.partnerKey} />
            </React.Fragment>
          )
        }
        
        {
          !this.state.partnerKey && (
            <React.Fragment>
              <i>
                Documentos generados entre 
                <div className="inlineDateWrapper">
                  <DateTimePicker
                    calendar time={false} format="YYYY-MM-DD"
                    value={this.state.from && moment(this.state.from, "YYYY-MM-DD").toDate()}
                    onChange={d => this.setState({ from: date2str(d, "-") }) }
                  />
                </div>
                y 
                <div className="inlineDateWrapper">
                  <DateTimePicker
                    calendar time={false} format="YYYY-MM-DD"
                    value={this.state.to && moment(this.state.to, "YYYY-MM-DD").toDate()}
                    onChange={d => this.setState({ to: date2str(d, "-") }) }
                  />
                </div>
                (ambos incluidos).
                <Button glyph="refresh" onClick={() => this.refresh()}>Actualizar</Button>
              </i>
              <DocumentedTrips 
                Trips={this.props.Trips}
                showModal={(tripId, i) => this.showModal(tripId, i)}
                documentedTripsList={documentedTripsList}
                addNoPubliTag={tripId => this.addNoPubliTag(tripId)}
                publiActivitiesSet={publiActivitiesSet}
                partners={this.state.partners}
                noPubliTagId={this.props.noPubliTagId}
              />
            </React.Fragment>
          )
        }
        
        {
          showDocModal && (
            <Modal show onHide={() => this.hideModal()}>
              <Modal.Header closeButton>
                <Modal.Title>Detalles de propuesta</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p><Timestamp ts={modalDoc.timestamp} /></p>
                Páginas opcionales seleccionadas (<HoverTip text={pagesExplanation}><Glyphicon glyph="question-sign" /></HoverTip>):
                <ul>
                  {
                    modalDoc.selectedActivities.map(key => (
                      /* this key is often an activity id. sometimes it's not, 
                       * for there are other pages in the document that are optional,
                       * like Madrid's description */
                      <li key={key}>{this.renderActivityMaybe(key)}</li>
                    ))
                  }
                </ul>
              </Modal.Body>
            </Modal>
          )
        }
        
        {/* <hr />
        <Panel>
          <Panel.Heading>this.state</Panel.Heading>
          <Panel.Body>
            <Json src={this.state} />
          </Panel.Body>
        </Panel> */}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const Trips = getAllTrips(state, props)
  const Activities = getAllActivities(state, props)
  return {
    Trips, 
    Activities,
    noPubliTagId: getNoPubliTagId(state, props),
  }
}

const mapDispatchToProps = (dispatch, _props) => ({
  updateTags: (id, tags) => dispatch(updateTrip(id, { tags })),
})


export default connect(mapStateToProps, mapDispatchToProps)(AdvertisingPage)